import React, { useEffect, useMemo } from 'react';
import styles from '../style.module.scss';

const getBlobURL = code => {
  const blob = new Blob([code], { type: 'text/html' });
  return URL.createObjectURL(blob);
};

// Renders the SCA/3DS challenge. Either an HTML document (`iframeHtml`, served through a Blob URL)
// or a URL the payment provider supplied (`src`); `src` wins when both are given.
const ScaIframe = ({ iframeHtml, src }) => {
  const blobUrl = useMemo(() => (src || !iframeHtml ? null : getBlobURL(iframeHtml)), [
    src,
    iframeHtml,
  ]);

  useEffect(() => {
    return () => {
      if (blobUrl && typeof URL.revokeObjectURL === 'function') {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [blobUrl]);

  return (
    <div className={styles.scaChallengeContainer}>
      <iframe id="sca-challenge" src={src || blobUrl} title="sca-challenge" />
    </div>
  );
};

export default React.memo(ScaIframe);
